export const reducer = (state, action) => {
  switch (action.type) {
    case 'update_saved_views':
      return {
        savedViews: action.savedViews,
      }

    default:
      return state
  }
}

export const initialState = {
  savedViews: null,
}
